module.exports = __webpack_public_path__ + "img/ic_head_hight_9.b30d5af3.png";